const IDENTIFIER_REQUIRED_ERROR = 'email or phone is required';
const CHANNEL_ERROR = 'channel must be email or sms';
const ALLOWED_CHANNELS = new Set(['email', 'sms']);

/**
 * Wire contract is email XOR phone. When the payer profile supplies both
 * (post Lookup-identifier UI), prefer email and still emit a single key.
 */
export const buildPalIfpCredentialIdentifierPayload = (source = {}) => {
  const hasEmail = Boolean(source.email);
  const hasPhone = Boolean(source.phone);

  if (!hasEmail && !hasPhone) {
    throw new Error(IDENTIFIER_REQUIRED_ERROR);
  }

  if (hasEmail) {
    return { email: source.email };
  }

  return { phone: source.phone };
};

export const buildPalIfpPasswordResetPayload = (source = {}) => {
  const identifier = buildPalIfpCredentialIdentifierPayload(source);
  const { channel } = source;

  if (!channel || !ALLOWED_CHANNELS.has(channel)) {
    throw new Error(CHANNEL_ERROR);
  }

  return { ...identifier, channel };
};
